// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"127":"41290e36","150":"c574178c","437":"9c37b5de","521":"935aaa18","549":"1e0b725b","560":"7ca314d7","929":"6994b47d"}[chunkId] + ".css";
};